import React from 'react'
import { SortableContainer } from 'react-sortable-hoc'

// Components
import SortableElement from './SortableElement'

export default SortableContainer(({ items, updateLoading }) => {
    return (
        <ul className="sortable">
            {items.map((value, index) => (
                <SortableElement key={`item-${index}`} index={index} value={value} updateLoading={updateLoading} disabled={updateLoading} />
            ))}
        </ul>
    )
})



// WEBPACK FOOTER //
// ./src/components/admin/categories-sort/SortableList.js